export default "__VITE_ASSET__Dv1b85H9__"